import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import errorSlice from "../../Services/errorSlice";
import usersService from "../../Services/users.service";
import labFormService from "../../Services/labForm.service";
import { alertSnackbarError, alertSnackbarSuccess } from "./alertStatusSlice";

const initialState = {
  loading: false,
  result: [],
};
export const labFormList = createAsyncThunk(
  "labForm/list",
  async (values, thunkAPI) => {
    try {
      const result = await labFormService.list(values).then((respone) => {
        const { data } = respone;
        return data.result;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);
export const labFormCreate = createAsyncThunk(
  "labForm/create",
  async (values, thunkAPI) => {
    try {
      const result = await labFormService.create(values).then((response) => {
        const { data } = response;
        if (data.status === true) {
          thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
        } else {
          thunkAPI.dispatch(alertSnackbarError(data.msg));
        }
        return data;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);
export const labFormUpdate = createAsyncThunk(
  "labForm/update",
  async (values, thunkAPI) => {
    try {
      const result = await labFormService.update(values).then((response) => {
        const { data } = response;
        if (data.status === true) {
          thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
        } else {
          thunkAPI.dispatch(alertSnackbarError(data.msg));
        }
        return data;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);
export const labFormDelete = createAsyncThunk(
  "labForm/delete",
  async (values, thunkAPI) => {
    try {
      const result = await labFormService.destroy(values).then((respone) => {
        const { data } = respone;
        if (data.status === true) {
          thunkAPI.dispatch(alertSnackbarSuccess(data.msg));
        } else {
          thunkAPI.dispatch(alertSnackbarError(data.msg));
        }
        return data;
      });
      return result;
    } catch (error) {
      errorSlice.error(error, thunkAPI);
    }
  }
);

export const labFormSlice = createSlice({
  name: "labFormSlice",
  initialState: initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(labFormList.pending, (state, action) => {
      state.loading = true;
      state.result = [];
    });
    builder.addCase(labFormList.fulfilled, (state, action) => {
      state.loading = false;
      state.result = action.payload;
    });
    builder.addCase(labFormList.rejected, (state, action) => {
      state.loading = false;
      state.result = [];
    });
  },
});

export const { reducer } = labFormSlice.actions;

export default labFormSlice.reducer;
